import React from "react";
import "./HowToBuy.css";
import { Container, Row, Col } from "react-bootstrap";
import HomeLeft from "../Components/HomeLeft";
import HomeRight from "../Components/HomeRight";
import icon1 from './assets/icon1.png';
import icon2 from './assets/icon2.png';
import icon3 from './assets/icon3.png';
import icon4 from './assets/icon4.png';
import icon5 from './assets/icon5.png';
import icon6 from './assets/icon6.png';
import icon7 from './assets/icon7.png';
import icon8 from './assets/icon8.png';

const HowToBuy = () => {
    return (
        <div className="row">
            <div className="col-1 leftcol">
                {/* <HomeLeft /> */}
            </div>
            <div className="col-10 middlecol">
                <Container className="how-to-buy my-5">
                    <h2 className="text-uppercase">Simple Steps and Detailed Follows for Our Customer's Satisfaction</h2>
                    <Row className="steps mt-4">
                        <Col md={12} className="step">
                            <img src={icon1} alt="Car" className="icon" />
                            <p>Pick your wanted unit from our stock or from our Direct Auction Access.</p>
                        </Col>
                        <Col md={12} className="step">
                            <img src={icon2} alt="Money" className="icon" />
                            <p>Send 50% - 100% of the agreed vehicle price before shipment.</p>
                        </Col>
                        <Col md={12} className="step">
                            <img src={icon3} alt="Inspection" className="icon" />
                            <p>Export Pre-inspection will take place for the required markets.</p>
                        </Col>
                        <Col md={12} className="step">
                            <img src={icon4} alt="Ship" className="icon" />
                            <p>Your vehicle will be shipped.</p>
                        </Col>
                        <Col md={12} className="step">
                            <img src={icon5} alt="Document" className="icon" />
                            <p>The BL scan will be supplied.</p>
                        </Col>
                        <Col md={12} className="step">
                            <img src={icon6} alt="Money" className="icon" />
                            <p>Send the final balance of the purchased unit after departure.</p>
                        </Col>
                        <Col md={12} className="step">
                            <img src={icon7} alt="DHL" className="icon" />
                            <p>Documents will be sent via DHL, and the tracking number will be supplied.</p>
                        </Col>
                        <Col md={12} className="step">
                            <img src={icon8} alt="Handshake" className="icon" />
                            <p>Once the DHL is received, you are ready to clear the unit at the port, and the car is yours!</p>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className="col-1 rightcol">
                {/* <HomeRight /> */}
            </div>
        </div>
    );
};

export default HowToBuy;